import { compareAsc, parseJSON } from "date-fns";

import { basicMsg } from "../helpers/swal_msg";

import { regex_email, regex_num, regex_phone } from "../constants/regex";

export const form1Validator = (
    { name, professionalID, email, phone, especialidad },
    institutions
) => {
    let msg = [];
    const len1 = name.trim().length;
    const len2 = professionalID.trim().length;
    const len3 = email.trim().length;
    const len4 = phone.trim().length;
    if (len1 > 5 && len1 <= 150) {
        if (len2 > 6 && len2 <= 8) {
            if (email.trim() === '' || (len3 > 2 && len3 <= 100 && regex_email.test(email.trim()))) {
                if (len4 > 2 && len4 <= 10 && regex_phone.test(phone)) {
                    if (especialidad > 0)
                        return form2Validator(institutions);
                    else msg = [...msg, 'Seleccione la especialidad'];
                } else msg = [...msg, 'Ingrese número de teléfono'];
            } else msg = [...msg, 'Ingrese correo electrónico (Opcional)'];
        } else msg = [...msg, 'Ingrese cédula profesional'];
    } else msg = [...msg, 'Ingrese nombre completo de Médico'];
    return { status: false, msg };
};

const form2Validator = (institutions) => {
    let msg = [];
    for (let [i, e] of institutions.entries()) {
        const j = i+1;
        const {
            type, street, num_ext, num_int,
            postalCode, colony, city, state,
            schedules, check
        } = e;
        const len2 = street.trim().length;
        const len3 = num_ext.trim().length;
        const len4 = num_int.trim().length;
        const len5 = postalCode.trim().length;
        const len6 = colony.trim().length;
        const len7 = city.trim().length;
        const len8 = state.trim().length;
        if (type > 0) {
            if (len2 > 2 && len2 <= 100) {
                if (len3 > 1 && len3 <= 4 && regex_num.test(num_ext)) {
                    if (num_int.trim() === '' || (len4 >= 1 && len4 <= 6)) {
                        if (len5 === 5 && regex_num.test(postalCode)) {
                            if (len6 > 2 && len6 <= 60) {
                                if (len7 > 2 && len7 <= 60) {
                                    if (len8 > 2 && len8 <= 60) {
                                        if (check) {
                                            const messages = form3Validator(j, schedules);
                                            msg = [...msg, ...messages];
                                        }
                                    } else msg = [...msg, `Ingrese estado de institución (No. ${j})`];
                                } else msg = [...msg, `Ingrese ciudad de institución (No. ${j})`];
                            } else msg = [...msg, `Ingrese colonia de institución (No. ${j})`];
                        } else msg = [...msg, `Ingrese código postal de institución (No. ${j})`];
                    } else msg = [...msg, `Ingrese número interior de institución (No. ${j}) [opcional]`];
                } else msg = [...msg, `Ingrese número exterior de institución (No. ${j})`];
            } else msg = [...msg, `Ingrese calle de institución (No. ${j})`];
        } else msg = [...msg, `Ingrese tipo de institución (No. ${j})`];
    };
    return msg.length > 0 ? { status: false, msg } : { status: true, msg };
};

const form3Validator = (j, schedules) => {
    let msg = [];
    const { sunday, monday, tuesday, wednesday, thursday, friday, saturday } = schedules;
    const msg1 = validateDay(j, 'domingo', sunday);
    const msg2 = validateDay(j, 'lunes', monday);
    const msg3 = validateDay(j, 'martes', tuesday);
    const msg4 = validateDay(j, 'miércoles', wednesday);
    const msg5 = validateDay(j, 'jueves', thursday);
    const msg6 = validateDay(j, 'viernes', friday);
    const msg7 = validateDay(j, 'sábado', saturday);
    if (msg1) msg = [...msg, msg1];
    if (msg2) msg = [...msg, msg2];
    if (msg3) msg = [...msg, msg3];
    if (msg4) msg = [...msg, msg4];
    if (msg5) msg = [...msg, msg5];
    if (msg6) msg = [...msg, msg6];
    if (msg7) msg = [...msg, msg7];
    return msg.length > 0 ? msg.slice(0, 1) : msg;
};

const validateDay = (j, day_text, { enabled, start_date, end_date, start_period, end_period }) => {
    let msg = '';
    if (enabled) {
        if (start_date && end_date) {
            const first_array = start_date.split(":").map(
                (e, i) => i === 0 ? start_period === 'pm' ? String(Number(e) + 12) : e : e
            );
            const first_date = parseJSON(`1970-01-01 ${first_array.join(":")}:00 UTC`);
            const second_array = end_date.split(":").map(
                (e, i) => i === 0 ? end_period === 'pm' ? String(Number(e) + 12) : e : e
            );
            const second_date = parseJSON(`1970-01-01 ${second_array.join(":")}:00 UTC`);
            if (compareAsc(first_date, second_date) > -1)
                msg = getMsg(`Disponibilidad día ${day_text} no es posible, revise el horario`, j);
        } else msg = getMsg(`Ingrese disponibilidad de día ${day_text}`, j);
    }
    return msg;
};

// retornar posición de institución
const getMsg = (text, j) => {
    return j > -1 ? `${text}, institución No. ${j}` : text;
};

export const form4Validator = (
    { name, professionalID, email, phone, especialidad }
) => {
    let msg = '';
    const len1 = name.trim().length;
    const len2 = professionalID.trim().length;
    const len3 = email.trim().length;
    const len4 = phone.trim().length;
    if (len1 > 5 && len1 <= 150) {
        if (len2 > 6 && len2 <= 8) {
            if (email.trim() === '' || (len3 > 2 && len3 <= 100 && regex_email.test(email.trim()))) {
                if (len4 > 2 && len4 <= 10 && regex_phone.test(phone)) {
                    if (especialidad > 0)
                        return true;
                    else msg = 'Seleccione la especialidad';
                } else msg = 'Ingrese número de teléfono';
            } else msg = 'Ingrese correo electrónico (Opcional)';
        } else msg = 'Ingrese cédula profesional';
    } else msg = 'Ingrese nombre completo de Médico';
    basicMsg(msg);
    return false;
};

export const form5Validator = (institution) => {
    let msg = '';
    const {
        idTipoHospital, street, num_ext, num_int,
        postalCode, colony, city, state,
        schedules, check
    } = institution;
    const len2 = street.trim().length;
    const len3 = num_ext.trim().length;
    const len4 = num_int.trim().length;
    const len5 = postalCode.trim().length;
    const len6 = colony.trim().length;
    const len7 = city.trim().length;
    const len8 = state.trim().length;
    if (idTipoHospital > 0) {
        if (len2 > 2 && len2 <= 100) {
            if (len3 > 1 && len3 <= 4 && regex_num.test(num_ext)) {
                if (num_int.trim() === '' || (len4 >= 1 && len4 <= 6)) {
                    if (len5 === 5 && regex_num.test(postalCode)) {
                        if (len6 > 2 && len6 <= 60) {
                            if (len7 > 2 && len7 <= 60) {
                                if (len8 > 2 && len8 <= 60) {
                                    if (check) {
                                        const messages = form3Validator(-1, schedules);
                                        if (messages.length > 0)
                                            msg = messages[0];
                                        else
                                            return true;
                                    } else return true;
                                } else msg = `Ingrese estado de institución`;
                            } else msg = `Ingrese ciudad de institución`;
                        } else msg = `Ingrese colonia de institución`;
                    } else msg = `Ingrese código postal de institución`;
                } else msg = `Ingrese número interior de institución`;
            } else msg = `Ingrese número exterior de institución`;
        } else msg = `Ingrese calle de institución`;
    } else msg = `Ingrese tipo de institución`;
    basicMsg(msg);
    return false;
};